import { queryOptions, useQuery } from "@tanstack/react-query";

import data from "../../assets/mocks/watchlists.json";

import { api } from "@/lib/api-client";
import { hasAccessToken } from "@/lib/auth";
import { AxiosMock } from "@/utils/mock";

import type { QueryConfig } from "@/lib/react-query";
import type { Watchlists } from "@/types/watchlist";

if (import.meta.env.MODE === "test") {
  // Mocking the API response for watchlists
  const mock = AxiosMock.getInstance();
  mock.onGet("/carburate/watchlists/").reply(200, data);
}

export const getWatchlists = () => {
  return api.get("/carburate/watchlists/") as Promise<Watchlists>;
};

export const getWatchlistsQueryOptions = () => {
  return queryOptions({
    queryKey: ["watchlists"],
    queryFn: getWatchlists,
  });
};

type UseWatchlistsOptions = {
  queryConfig?: QueryConfig<typeof getWatchlists>;
};

export const useWatchlists = ({ queryConfig }: UseWatchlistsOptions = {}) => {
  return useQuery({
    enabled: hasAccessToken(),
    ...getWatchlistsQueryOptions(),
    refetchOnWindowFocus: true,
    ...queryConfig,
  });
};
